import { useFormik } from "formik";
import { useContext, useMemo } from "react";
import { useAlert } from "react-alert";
import { Animated } from "react-animated-css";
import { useHistory, useLocation } from "react-router-dom";
import { useUpdateUser } from "../api/hooks";
import { BYPasswordInput } from "../common/inputs/BYPasswordInput";
import { ChangePasswordSchema } from "../common/types/Schemas";
import Footer from "../common/views/Footer";
import { AuthContext } from "../providers/AuthProvider";

export const ChangePasswordScreen = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const history = useHistory();
  const { search } = useLocation();

  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  const { mutateAsync: mutateUser } = useUpdateUser(true);

  const formik = useFormik({
    initialValues: {
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: ChangePasswordSchema,
    onSubmit: async (values) => {
      try {
        await mutateUser({ userId: user.refUti, values });

        alert.success("Utilisateur mis à jour");

        const redirect = queryParams.get("r")
          ? decodeURIComponent(queryParams.get("r"))
          : undefined;

        if (redirect) {
          return history.push(redirect);
        }

        return history.push("/");
      } catch (error) {
        const statusCode = error.response && error.response.status;

        if (statusCode === 401) {
          alert.error("Valeurs invalides ou incomplètes");
        } else if (statusCode === 409) {
          alert.error(error.response.data);
        } else {
          alert.error(error.message);
        }
      }
    },
  });

  return (
    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} className="flex-grow-1">
      <div className="container h-100">
        <form onSubmit={formik.handleSubmit} autoComplete="new-password">
          <div className="row">
            <div className="col-8">
              <h4 className="my-4 color-green">Mot de passe expiré</h4>
              <h5 className="my-2">Modification de mot de passe</h5>
            </div>
          </div>

          <div className="input-container">
            <div className="row mb-3">
              <div className="col">
                <BYPasswordInput
                  name="password"
                  title="Nouveau mot de passe"
                  autoComplete="new-password"
                  value={formik.values.password}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  required={true}
                  touched={formik.touched.password}
                  error={formik.errors.password}
                />
              </div>
              <div className="col">
                <BYPasswordInput
                  name="passwordConfirmation"
                  title="Confirmation de mot de passe"
                  autoComplete="off"
                  value={formik.values.passwordConfirmation}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  required={true}
                  touched={formik.touched.passwordConfirmation}
                  error={formik.errors.passwordConfirmation}
                />
              </div>
            </div>
          </div>

          <div className="d-flex my-5">
            <button
              className="btn btn-secondary flex-grow-1"
              type="submit"
              disabled={!formik.isValid}
            >
              Sauvegarder <i className="fa fa-save" />
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </Animated>
  );
};
